import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
export function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-20 sm:pt-24" data-id="element-556" data-mp="25b5z12i2wb94">
      <section className="page-header" data-id="element-557" data-mp="2k7dg3ty6wwk6">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-558" data-mp="2k496gh1yh8m4">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-end" data-id="element-559" data-mp="2f6g3dwvy8uq2">
            <div className="max-w-3xl" data-id="element-560" data-mp="2xys3ecz4rjx1">
              <p className="eyebrow" data-id="element-561" data-mp="2xztnt821dirf">Información legal</p>
              <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-562" data-mp="3byjm2r0ldohd">
                Términos y Condiciones
              </h1>
            </div>
            <p className="border-l border-white/15 pl-5 text-xs leading-relaxed text-neutral-400 lg:max-w-[185px]" data-id="element-563" data-mp="2vnpkyy1c9y18">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
              month: 'long',
              year: 'numeric'
            })}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10" data-id="element-564" data-mp="39kw2yqe8nspe">
        <div className="container mx-auto max-w-5xl px-6 md:px-12" data-id="element-565" data-mp="3eladcf3bbeql">
          <motion.article initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="mx-auto max-w-3xl border-x border-t border-white/10" aria-label="Contenido de los términos y condiciones" data-id="element-566" data-mp="3in59z6aat3y1">
            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-567" data-mp="3cn8yph6z9k04">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-568" data-mp="37ofktnns3qzf">
                1. Objeto
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-569" data-mp="3mdtrgnzyzub4">
                Los presentes Términos y Condiciones regulan el uso de los
                servicios ofrecidos por Growthly Corporation Systems (en
                adelante, "Growthly" o
                "la Agencia") a través de su sitio web, así como las condiciones
                de contratación de los servicios de diseño, desarrollo web y
                creación de ecosistemas digitales para empresas.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-570" data-mp="48gu191hkz1u">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-571" data-mp="2ayoqppjeg5u5">
                2. Servicios contratados
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-572" data-mp="lh19sh5hvob3">
                Growthly ofrece servicios integrales de presencia digital, que
                incluyen, pero no se limitan a:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-573" data-mp="bq6n5boc6mp4">
                <li data-id="element-574" data-mp="gogknsxj9zdw">Diseño y desarrollo de páginas web profesionales.</li>
                <li data-id="element-575" data-mp="2pgxyqtkzukd">Creación de menús y cartas digitales interactivas.</li>
                <li data-id="element-576" data-mp="6smyrixxctjg">Gestión integral y mantenimiento técnico continuo.</li>
                <li data-id="element-577" data-mp="3oxq6zcj6tlo3">Consultoría estratégica digital.</li>
              </ul>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-578" data-mp="3ozkrwquglds6">
                Las especificaciones exactas de cada proyecto se detallarán en
                la propuesta comercial aceptada por el cliente.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-579" data-mp="1s4578j6vkwe6">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-580" data-mp="3o7jnvk77hfsu">
                3. Precio y forma de pago
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-581" data-mp="3j7f4nmewy6yx">
                El precio de nuestro servicio estándar de ecosistema digital es
                de <strong className="font-medium text-white" data-id="element-582" data-mp="3a8bmcknklvlh">350€</strong>{' '}
                (impuestos incluidos, salvo indicación contraria). Se trata de
                un{' '}
                <strong className="font-medium text-white" data-id="element-583" data-mp="30hz3cwvemahg">
                  pago único por adelantado
                </strong>{' '}
                que incluye la creación de la página web y su gestión y
                mantenimiento completos, sin cuotas ni cargos posteriores.
              </p>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-584" data-mp="2mi7icc6gztty">
                El pago se realiza mediante transferencia bancaria a los datos
                facilitados al confirmar el proyecto. Los trabajos comienzan una
                vez confirmada la transferencia.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-585" data-mp="123b4o0oxqt3x">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-586" data-mp="1712u8o23y34y">
                4. Plazos de entrega
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-587" data-mp="ebvx9tiaxllt">
                Los plazos de entrega se acordarán de forma individualizada con
                cada cliente tras la confirmación del pago. Growthly se
                compromete a cumplir los plazos establecidos, siempre y cuando
                el cliente proporcione el material y la información necesaria
                (textos, imágenes, accesos) en los tiempos requeridos. Los
                retrasos imputables al cliente modificarán proporcionalmente la
                fecha de entrega final.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-588" data-mp="12wlqvf5xm8hx">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-589" data-mp="xzc11yemrutk">
                5. Obligaciones del cliente
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-590" data-mp="1cpjbbquhi7j6">
                El cliente se compromete a:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-591" data-mp="jxzolwyoibcf">
                <li data-id="element-592" data-mp="f19b9he9dtup">Proporcionar información veraz y completa.</li>
                <li data-id="element-593" data-mp="szpntoysyekr">
                  Entregar los materiales necesarios para el desarrollo del
                  proyecto en los plazos acordados.
                </li>
                <li data-id="element-594" data-mp="24emjhhphs213">
                  Abonar los importes correspondientes en las fechas
                  estipuladas.
                </li>
                <li data-id="element-595" data-mp="20c9b0ljd1q0m">
                  Garantizar que posee los derechos de autor o licencias de uso
                  de cualquier material (imágenes, textos, logotipos)
                  proporcionado a la Agencia.
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-596" data-mp="1xz5t1njsnmy3">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-597" data-mp="22x7eug8lu0d9">
                6. Propiedad intelectual
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-598" data-mp="2qnjt08ug0tca">
                Una vez abonado el 100% del importe del proyecto, el cliente
                adquiere los derechos de explotación sobre el producto final
                entregado (página web, diseños). Growthly se reserva el derecho
                de mostrar el proyecto en su portfolio, casos de éxito y
                material promocional, salvo que se firme un acuerdo de
                confidencialidad (NDA) específico.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-599" data-mp="1eawfv20eqty6">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-600" data-mp="19jwk4030yhx9">
                7. Responsabilidad
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-601" data-mp="15j45ssfapmu4">
                Growthly no se hace responsable de las caídas de servidores de
                terceros (hosting), problemas con proveedores de dominio, o
                cambios en los algoritmos de plataformas externas (Google, Meta)
                que puedan afectar al rendimiento del ecosistema digital una vez
                entregado.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-602" data-mp="1j9zbjvuhznth">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-603" data-mp="ct42uz4cujtw">
                8. Cancelaciones y reembolsos
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-604" data-mp="7sps39bdcvs6">
                El cliente tiene derecho a la devolución íntegra del pago (350€)
                si decide cancelar el proyecto antes de la presentación de la
                primera propuesta de diseño. Una vez presentados los primeros
                trabajos o propuestas, el importe no será reembolsable en su
                totalidad, ya que cubre los gastos operativos y de consultoría
                inicial.
              </p>
            </section>

            <section className="px-6 py-8 sm:px-10 sm:py-10" data-id="element-605" data-mp="lfoigjsseg4w">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-606" data-mp="le3qn1xuxbaq">
                9. Legislación aplicable
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-607" data-mp="vdunha9w42dz">
                Estos Términos y Condiciones se rigen por la legislación
                española. Para la resolución de cualquier controversia que
                pudiera derivarse de la prestación de los servicios, las partes
                se someten a los Juzgados y Tribunales competentes.
              </p>
            </section>
          </motion.article>
        </div>
      </section>
    </div>;
}